const state = {
    jobDescription: {
        id: '',
        job_title: "",
        job_grade: "",
        organizational_unit: "",
        supervisor: "",
        job_definition: "",
        job_purpose: "",
        job_responsibilities: "",
        work_conditions: "",
        hazards: "",
        ergonomics: "",
        stress_factors: ""
    }
};

const mutations = {
    setJobDescription(state, value) {
        state.jobDescription = value;
    },
};

const actions = {};

const getters = {
    jobDescription: state => state.jobDescription,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
